// Initial avatar (cloud bg + ink letter — v3.1 icon tiles are cloud + ink).

export interface AvatarProps {
  name?: string | null;
  size?: number;
  /** 'circle' (people) or 'square' (businesses, 8 px radius, teal tint). */
  shape?: 'circle' | 'square';
  label?: string;
}

export function initialOf(name?: string | null): string {
  const n = (name ?? '').replace(/^(د\.|أ\.|م\.)\s*/, '').trim();
  return n.charAt(0) || '؟';
}

export function Avatar({ name, size = 32, shape = 'circle', label }: AvatarProps) {
  return (
    <span
      className={`e-avatar e-avatar--${shape}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
      role="img"
      aria-label={label ?? name ?? undefined}
    >
      {initialOf(name)}
    </span>
  );
}
